import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { ItabItem, renderIntlLabel } from '@/utils';
import ManualTabItem from './ManualTabItem';

const { TabPane } = Tabs;

const ManualTab = ({ dataSource = [], loading }) => {
  const tabList: Array<ItabItem> = useMemo(() => {
    // status 0未使用，1已使用
    const unusedList = dataSource?.find((item) => item.status === 0)?.xzCouponList;
    const usedList = dataSource?.find((item) => item.status === 1)?.xzCouponList;
    return [
      {
        key: 'unused',
        tab: renderIntlLabel('guest_coupon_tab_have_been_unused'),
        component: <ManualTabItem isUsed={false} dataSource={unusedList} loading={loading} />,
      },
      {
        key: 'used',
        tab: renderIntlLabel('guest_coupon_tab_have_been_used'),
        component: <ManualTabItem isUsed dataSource={usedList} loading={loading} />,
      },
    ];
  }, [dataSource, loading]);

  return (
    <>
      <Tabs>
        {tabList?.map((item) => (
          <TabPane tab={item.tab} key={item.key}>
            {item.component}
          </TabPane>
        ))}
      </Tabs>
    </>
  );
};

export default ManualTab;
